module.exports = __webpack_public_path__ + "statics/img/user-img02.3813b1a9.png";